import { z } from 'zod'

/** Lifecycle of a bike in the garage. */
export const BikeStatus = z.enum(['active', 'stored', 'building', 'sold', 'retired'])
export type BikeStatus = z.infer<typeof BikeStatus>

export const BikeType = z.enum([
  'mtb_full',
  'mtb_hardtail',
  'mtb_rigid',
  'gravel',
  'road',
  'cx',
  'commuter',
  'ebike',
  'bmx',
  'other',
])
export type BikeType = z.infer<typeof BikeType>

/**
 * Component categories. Each category has its own set of standards in
 * `specs` (see schemas/component-specs.ts). Add to the end; never rename a
 * value that has been stored.
 */
export const ComponentCategory = z.enum([
  'frame',
  'fork',
  'shock',
  'wheel',
  'hub',
  'rim',
  'tyre',
  'inner_tube',
  'chain',
  'cassette',
  'chainring',
  'crankset',
  'bottom_bracket',
  'derailleur_rear',
  'derailleur_front',
  'shifter',
  'brake',
  'brake_pads',
  'brake_rotor',
  'headset',
  'stem',
  'handlebar',
  'grips',
  'seatpost',
  'saddle',
  'pedals',
  'cables',
  'sealant',
  'other',
])
export type ComponentCategory = z.infer<typeof ComponentCategory>

export const ComponentStatus = z.enum(['in_use', 'spare', 'worn_out', 'sold', 'binned'])
export type ComponentStatus = z.infer<typeof ComponentStatus>

export const InstallPosition = z.enum(['front', 'rear', 'none'])
export type InstallPosition = z.infer<typeof InstallPosition>

export const CaptureState = z.enum(['inbox', 'converted', 'dismissed'])
export type CaptureState = z.infer<typeof CaptureState>

/** `safety` jobs are flagged red and never deferred. */
export const JobPriority = z.enum(['safety', 'normal', 'low'])
export type JobPriority = z.infer<typeof JobPriority>

export const JobStatus = z.enum(['open', 'in_progress', 'done', 'cancelled'])
export type JobStatus = z.infer<typeof JobStatus>

export const PhotoTag = z.enum([
  'hero',
  'before_strip',
  'damage',
  'serial',
  'build',
  'receipt',
  'general',
])
export type PhotoTag = z.infer<typeof PhotoTag>

export const PhotoOwnerType = z.enum(['bike', 'component', 'job', 'capture', 'service_record'])
export type PhotoOwnerType = z.infer<typeof PhotoOwnerType>

export const RideSource = z.enum(['strava', 'manual', 'file', 'apple_health', 'health_connect'])
export type RideSource = z.infer<typeof RideSource>

export const IntervalBasis = z.enum(['distance', 'hours', 'days'])
export type IntervalBasis = z.infer<typeof IntervalBasis>

export const UnitsPreference = z.enum(['metric', 'imperial'])
export type UnitsPreference = z.infer<typeof UnitsPreference>

export const Plan = z.enum(['free', 'paid'])
export type Plan = z.infer<typeof Plan>
